import { Component, OnDestroy, OnInit } from '@angular/core';
import { Globals } from '../../_globals';
import { ActivatedRoute } from '@angular/router';
import { NotificationBadgeService, WorkOrderCountBadgeState } from 'app/_services/notification-badge.service';
import { MenuBadge } from '../MenuBadge';

declare interface RouteInfo {
  requirement?: string;
  path: string;
  title: string;
  icon: string;
  class: string;
  children: any;
  badgeKey?: string;
  badge?: MenuBadge;
}

export const ADMINROUTES: RouteInfo[] = [
  { path: '/admin/dashboard', title: 'Dashboard', icon: 'fas fa-qrcode', class: '', children: [] },
  { path: '/admin/live-sessions', title: 'Live Sessions', icon: 'fas fa-heart', class: '', children: [] },
  { path: '/admin/sites', title: 'Manage Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { path: '/admin/work-orders', title: 'Work Orders', icon: 'fas fa-clone', class: '', children: [], badgeKey: 'workOrders' },
  { path: '/admin/contractors', title: 'Contractors', icon: 'fas fa-industry', class: '', children: [] },
  { path: '/admin/user-management', title: 'Users', icon: 'fas fa-users', class: '', children: [] },
  { path: '/admin/schedule', title: 'Schedule', icon: 'fas fa-calendar-minus', class: '', children: [] },
  { path: '/admin/type-management', title: 'Types', icon: 'fas fa-cubes', class: '', children: [] },
  { path: '/admin/site-map', title: 'Site Map', icon: 'fas fa-map-marked-alt', class: '', children: [] },
  { path: '/admin/training', title: 'Inductions / Training', icon: 'fa-solid fa-chalkboard-user', class: '', children: [] },
  { path: '/admin/site-forms', title: 'Site Forms', icon: 'fa fa-tasks', class: '', children: [] },
  { path: '/admin/reports', title: 'Reporting', icon: 'fa-regular fa-file', class: '', children: [] },
];

export const SUPPORTROUTES: RouteInfo[] = [
  { path: '/support/dashboard', title: 'Dashboard', icon: 'fas fa-qrcode', class: '', children: [] },
  { path: '/support/live-sessions', title: 'Live Sessions', icon: 'fas fa-heart', class: '', children: [] },
  { path: '/support/sites', title: 'Manage Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { path: '/support/work-orders', title: 'Work Orders', icon: 'fas fa-clone', class: '', children: [], badgeKey: 'workOrders' },
  { path: '/support/contractors', title: 'Contractors', icon: 'fas fa-industry', class: '', children: [] },
  { path: '/support/user-management', title: 'Users', icon: 'fas fa-users', class: '', children: [] },
  { path: '/support/schedule', title: 'Schedule', icon: 'fas fa-calendar-minus', class: '', children: [] },
  { path: '/support/type-management', title: 'Types', icon: 'fas fa-cubes', class: '', children: [] },
  { path: '/support/site-map', title: 'Site Map', icon: 'fas fa-map-marked-alt', class: '', children: [] },
  { path: '/support/training', title: 'Inductions / Training', icon: 'fa-solid fa-chalkboard-user', class: '', children: [] },
  { path: '/support/site-forms', title: 'Site Forms', icon: 'fa fa-tasks', class: '', children: [] },
  { path: '/support/reports', title: 'Reporting', icon: 'fa-regular fa-file', class: '', children: [] },
];

export const CONTRACTOR_MANAGER_ROUTES: RouteInfo[] = [
  { path: '/contractor-manager/dashboard', title: 'Dashboard', icon: 'fas fa-qrcode', class: '', children: [] },
  { path: '/contractor-manager/company', title: 'Company Details', icon: 'fas fa-industry', class: '', children: [] },
  { path: '/contractor-manager/workers', title: 'Workers', icon: 'fas fa-users', class: '', children: [] },
  { path: '/contractor-manager/invite-users', title: 'Invite Users', icon: 'fas fa-mail-bulk', class: '', children: [] },
  { requirement: 'hasPowerstationRelation',  path: '/contractor-manager/outage-acceptance', title: 'Outage / Acceptance', icon: 'fa-solid fa-chalkboard-user', class: '', children: [] },
];

export const WORKERROUTES: RouteInfo[] = [
  { path: '/worker/my-sites', title: 'My Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { path: '/worker/training', title: 'My Training', icon: 'fas fa-chalkboard-user', class: '', children: [] },
  { path: '/worker/manage-competencies', title: 'My Competencies', icon: 'fas fa-id-card', class: '', children: [] },
  { path: '/worker/scheduling', title: 'Scheduling', icon: 'fas fa-calendar-minus', class: '', children: [] },
];

export const SITEOWNERROUTES: RouteInfo[] = [
  { path: '/site-owner/dashboard', title: 'Dashboard', icon: 'fas fa-qrcode', class: '', children: [] },
  { path: '/site-owner/live-sessions', title: 'Live Sessions', icon: 'fas fa-heart', class: '', children: [] },
  { path: '/site-owner/sites', title: 'Manage Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { requirement: 'asset-schedule', path: '/site-owner/schedule', title: 'Schedule', icon: 'fas fa-calendar-minus', class: '', children: [] },
  { path: '/site-owner/work-orders', title: 'Work Orders', icon: 'fas fa-clone', class: '', children: [], badgeKey: 'workOrders' },
  { path: '/site-owner/contractors', title: 'Contractors', icon: 'fas fa-industry', class: '', children: [] },
  { path: '/site-owner/workers', title: 'Users', icon: 'fa-solid fa-magnifying-glass', class: '', children: [] },
  { path: '/site-owner/invite-users', title: 'Invite Users', icon: 'fas fa-users', class: '', children: [] },
  { path: '/site-owner/site-map', title: 'Site Map', icon: 'fas fa-map-marked-alt', class: '', children: [] },
  { path: '/site-owner/training', title: 'Inductions / Training', icon: 'fa-solid fa-chalkboard-user', class: '', children: [] },
  { path: '/site-owner/site-forms', title: 'Site Forms', icon: 'fa fa-tasks', class: '', children: [] },
  { path: '/site-owner/reports', title: 'Reporting', icon: 'fa-regular fa-file', class: '', children: [] },
];

export const POWER_STATION_OWNER_ROUTES: RouteInfo[] = [
  { path: '/power-station-owner/sites', title: 'Site', icon: 'fas fa-city', class: '', children: [] },
  { path: '/power-station-owner/contractors', title: 'Contractors', icon: 'fas fa-id-badge', class: '', children: [] },
  { path: '/power-station-owner/invite-users', title: 'Invite Users', icon: 'fas fa-users', class: '', children: [] },
  { path: '/power-station-owner/training', title: 'Inductions / Training', icon: 'fa-solid fa-chalkboard-user', class: '', children: [] },
  { path: '/power-station-owner/reports/competency-reports', title: 'Reporting', icon: 'fa-regular fa-file', class: '', children: [] },
];

export const POWER_STATION_ADMIN_ROUTES: RouteInfo[] = [
  { path: '/power-station-manager/site', title: 'Site Workers', icon: 'fas fa-city', class: '', children: [] },
  { path: '/power-station-manager/contractors', title: 'Contractors', icon: 'fas fa-id-badge', class: '', children: [] },
  { path: '/power-station-manager/my-sites', title: 'My Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { path: '/power-station-manager/training', title: 'My Training', icon: 'fas fa-chalkboard-user', class: '', children: [] },
  { path: '/power-station-manager/manage-competencies', title: 'My Competencies', icon: 'fas fa-id-card', class: '', children: [] },
];

export const SITEDELEGATEROUTES: RouteInfo[] = [
  { path: '/site-delegate/dashboard', title: 'Dashboard', icon: 'fas fa-qrcode', class: '', children: [] },
  { path: '/site-delegate/live-sessions', title: 'Live Sessions', icon: 'fas fa-heart', class: '', children: [] },
  { path: '/site-delegate/sites', title: 'Manage Sites', icon: 'fas fa-sitemap', class: '', children: [] },
  { requirement: 'asset-schedule', path: '/site-delegate/schedule', title: 'Schedule', icon: 'fas fa-calendar-minus', class: '', children: [] },
  { path: '/site-delegate/work-orders', title: 'Work Orders', icon: 'fas fa-clone', class: '', children: [], badgeKey: 'workOrders' },
  { path: '/site-delegate/contractors', title: 'Contractors', icon: 'fas fa-industry', class: '', children: [] },
  { path: '/site-delegate/workers', title: 'Users', icon: 'fa-solid fa-magnifying-glass', class: '', children: [] },
  { path: '/site-delegate/invite-users', title: 'Invite Users', icon: 'fas fa-users', class: '', children: [] },
  { path: '/site-delegate/site-forms', title: 'Site Forms', icon: 'fa fa-tasks', class: '', children: [] },
  { path: '/site-delegate/reports', title: 'Reporting', icon: 'fa-regular fa-file', class: '', children: [] },
  { path: '/site-delegate/training', title: 'My Training', icon: 'fas fa-chalkboard-user', class: '', children: [] },
  { path: '/site-delegate/manage-competencies', title: 'My Competencies', icon: 'fas fa-id-card', class: '', children: [] },
];

export const AUTHORISING_OFFICER_ROUTES: RouteInfo[] = [
  { path: '/authorising-officer/workers', title: 'Workers', icon: 'fa-solid fa-magnifying-glass', class: '', children: [] },
  { path: '/authorising-officer/contractors', title: 'Contractors', icon: 'fas fa-industry', class: '', children: [] },
];

export const ROLE_TO_ROUTES_MAP = {
  1: WORKERROUTES,
  2: CONTRACTOR_MANAGER_ROUTES,
  3: SITEOWNERROUTES,
  4: SUPPORTROUTES,
  5: ADMINROUTES,
  7: SITEDELEGATEROUTES,
  9: POWER_STATION_OWNER_ROUTES,
  10: POWER_STATION_ADMIN_ROUTES,
  11: SITEDELEGATEROUTES,
  12: SITEDELEGATEROUTES,
  13: AUTHORISING_OFFICER_ROUTES,
};

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: any[];
  role: any;
  resolverData: any;
  actionRequiredWorkOrderPollingSubscription: any;
  workOrdersBadge: MenuBadge;
  public logoUrl: any;

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    public notificationBadgeService: NotificationBadgeService,
  ) {
    this.role = globals.user.role;
  }

  ngOnInit() {
    this.resolverData = this.route.snapshot.data;

    this.menuItems = ROLE_TO_ROUTES_MAP[this.role];

    this.removeMenuItemsThatDontMeetRequirements();

    this.addActionRequiredWorkOrderBadge();

    this.getMainLogoImage();

  }

  private removeMenuItemsThatDontMeetRequirements() {
    // asset-schedule routes
    const allowAssetScheduling = this.globals.siteOwnerToggles.allowAssetScheduling;

    if (!allowAssetScheduling) {
      this.menuItems = this.menuItems.filter((menuItem) => !menuItem.requirement || menuItem.requirement !== 'asset-schedule');
    }

    if (this.role === 2) {
      if (!this.globals.contractor.hasPowerstationRelation) {
        this.menuItems = this.menuItems.filter((menuItem) => !menuItem.requirement || menuItem.requirement !== 'hasPowerstationRelation');
      }
    }
  }

  ngOnDestroy() {
    if (this.actionRequiredWorkOrderPollingSubscription) {
      this.actionRequiredWorkOrderPollingSubscription.unsubscribe();
    }
  }

  private addActionRequiredWorkOrderBadge() {
    if (this.role === 3 || this.role === 4 || this.role === 5 || this.role === 7 || this.role === 11 || this.role === 12) {
      this.actionRequiredWorkOrderPollingSubscription = this.notificationBadgeService.getActionRequiredWorkOrderCount().subscribe((badgeState: WorkOrderCountBadgeState) => {
        if (badgeState.status === 'unknown') {
          this.workOrdersBadge = {
            text: '?',
            className: 'badge-danger',
            tooltip: 'Count unavailable. Refresh page if this persists.',
          };
        } else {
          const newCount = badgeState.count || 0;

          this.workOrdersBadge = {
            text: newCount.toString(),
            className: newCount > 0 ? 'badge-danger' : 'badge-secondary',
            tooltip: newCount + ' require action',
          };
        }

        this.menuItems = this.menuItems.map((menuItem: RouteInfo) => {
          if (menuItem.badgeKey === 'workOrders') {
            return { ...menuItem, badge: this.workOrdersBadge };
          } else {
            return menuItem;
          }
        });
      });
    }

    // power station owner
    if (this.role === 9) {
      this.menuItems = this.menuItems.map((menuItem: RouteInfo) => {
        if (menuItem.path === '/power-station-owner/sites') {
          return { ...menuItem, path: '/power-station-owner/sites/' + this.globals.powerStationOwner.mainSiteId + '/workers' };
        } else {
          return menuItem;
        }
      });
    }
    // power station manager
    if (this.role === 10) {
      this.menuItems = this.menuItems.map((menuItem: RouteInfo) => {
        if (menuItem.path === '/power-station-manager/site') {
          return { ...menuItem, path: '/power-station-manager/sites/' + this.globals.powerStationOwner.mainSiteId + '/workers' };
        } else {
          return menuItem;
        }
      });
    }
  }

  private getMainLogoImage() {
    this.logoUrl = './assets/img/logos/skylark-control-logo-blue-shade-6.svg';

    // site owner
    if (this.role === 3) {
      switch (this.globals.user.login) {
        case 'ventusenergy':
          this.logoUrl = './assets/img/white-label-logos/ventus-powered-by.png';
          break;
        case 'wfsoireland':
          this.logoUrl = './assets/img/white-label-logos/wfso-powered-by.png';
          break;
        default:
          this.logoUrl = './assets/img/logos/skylark-control-logo-blue-shade-6.svg';
          break;
      }
    }
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  public getHomePath(): string {
    if (this.menuItems && this.menuItems.length > 0) {
      return this.menuItems[0].path;
    }
    return '/';
  }
}
